module.exports = __webpack_public_path__ + "img/ic_round-headset-mic-yellow.99fbe3a8.svg";